import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    BooleanField,
    Filter,
    TextInput,
} from 'react-admin';

import UserActionsList from './UserActionsList'

const PersonFilter = (props) => (
    <Filter {...props}>
        <TextInput source="username" alwaysOn />
    </Filter>
);

const UserList = props => (
    <List {...props} filters={<PersonFilter />}
          bulkActionButtons={false}
          actions={<UserActionsList hasCreate={false}/>}
          filter={{ deleted: false }}
    >
        <Datagrid rowClick="show">
            <TextField source="username" />
            <BooleanField source="enable" />
        </Datagrid>
    </List>
);

export default UserList;
